<template>
  <span
    v-if="!type"
    class="rounded-md px-2 text-xs py-1 text-[var(--yellow100)] bg-[var(--yellow50)] font-semibold"
    >Inactive</span
  >

  <span
    v-if="type === true"
    class="px-2 text-xs py-1 ml-1 rounded-md text-[var(--green100)] bg-[var(--green50)] font-semibold"
    >Active</span
  >

  <span
    v-if="type === 'stopSale'"
    class="px-2 py-1 ml-1 text-xs font-semibold text-red-500 bg-red-300 rounded-md"
    >Sales Stopped</span
  >
</template>

<script>
export default {
  name: "IsSellingTag",
  props: ["type"],
};
</script>

<style></style>
